import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../Components/checkbox/Checkbox";
import ApiDropdown from "../../Components/DropDown/Apidropdown";
import FileUploader from "../../Components/FileUpload/FileUpload";
import Input from "../../Components/input/input";
import TaskGridLookup from "../../Components/Lookup/Lookup"; // Adjust the path based on your project structure
import config from "../../config";
import "../../Style/IncidentAdd.css";
import { ChangeData } from "../../utils/Change/changeTypes";
import { TaskData } from "../../utils/Task/taskTypes";
import { useFetchFullName } from "../Incidents/Hooks/useFetchFullName";
import { Change, initialChange } from "./Change";
import { RmaData } from "../../utils/Rma/rmaTypes";
import { KnowledgeBaseData } from "../../utils/KnowledgeBase/KnowledgeBaseTypes";
import { IncidentData } from "../../utils/Incident/incidentTypes";
import { ProblemData } from "../../utils/Problem/problemTypes";
import TextArea from "../../Components/TextArea/TextArea";
import "../../Style/ChangeAdd.css";
import { authFetch } from "../../utils/Security/authFetch";
import { joinMulti } from "../../utils/multiValue";
import ses from "../../Assets/ses.jpg";
import Button from "../../Components/button/button";
import { getRecipients } from "../../utils/Change/changeHandlers";

type Person = {
  id: number;
  name: string;
};
const ChangeAdd: React.FC = () => {
  const username = localStorage.getItem("username");
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const isUser = localStorage.getItem("isUser") === "true";
  const isallsite = localStorage.getItem("isAllSite");
  const isallnetwork = localStorage.getItem("isAllNetwork");
  const isalllink = localStorage.getItem("isAllLink");
  const [change, setChange] = useState<Change>(initialChange);
  const [showUserDialog, setShowUserDialog] = useState(false);
  const [customer, setCustomer] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [emails, setEmails] = useState<[]>();

  const navigate = useNavigate();
  const [isTaskLookupOpen, setIsTaskLookupOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState<
    (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  >([]);
  const [network, setNetwork] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [site, setSite] = useState<
    string | number | (string | number)[] | null
  >(null);
  const organization = localStorage.getItem("organization") || undefined;
  const handleOpenTaskLookup = () => setIsTaskLookupOpen(true);
  const handleCloseTaskLookup = () => setIsTaskLookupOpen(false);

  const handleTaskSelect = (
    tasks: (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  ) => {
    const ticketIds = tasks.map((t) => t.ticketId); // collect all selected ticketIds
    handleChange("relatedobject", ticketIds); // now this should be an array
    setSelectedTask(tasks); // you might rename this to selectedTasks now
  };

  useEffect(() => {
    const { urgency, impact } = change;
    if (!urgency || !impact) return;

    const key = `${urgency}-${impact}`;
    let priority = "";
    //console.log("${urgency}-${impact}", urgency, impact);
    if (key === "Critical-Critical") priority = "Critical";
    else if (
      key === "Critical-High" ||
      key === "High-High" ||
      key === "High-Critical"
    )
      priority = "High";
    else if (
      key === "Critical-Medium" ||
      key === "High-Medium" ||
      key === "Medium-High" ||
      key === "Medium-Medium" ||
      key === "Medium-Critical"
    )
      priority = "Medium";
    else if (
      key === "Low-Low" ||
      key === "Low-High" ||
      key === "Low-Medium" ||
      key === "Low-Critical" ||
      key === "Medium-Low" ||
      key === "High-Low" ||
      key === "Critical-Low"
    )
      priority = "Low";
    else if (
      key === "Medium-Low" ||
      key === "High-Low" ||
      key === "Critical-Low"
    )
      priority = "Low";
    setChange((prev) => ({
      ...prev,
      priority,
    }));
  }, [change.urgency, change.impact]);
  useFetchFullName((fullName: string) => {
    setChange((prev) => ({ ...prev, user: fullName }));
  });
  type ValType = string | number | (string | number)[] | null | undefined;

  const fetchCustomerData = async (val: ValType) => {
    try {
      let orgValue: string | number | (string | number)[];

      if (val === null || val === undefined) {
        orgValue = organization ?? "";
      } else {
        orgValue = val;
      }

      let orgQueryParam = "";

      if (Array.isArray(orgValue)) {
        orgQueryParam = orgValue
          .map((item) => encodeURIComponent(String(item)))
          .join(",");
      } else {
        orgQueryParam = encodeURIComponent(String(orgValue));
      }

      const responseIds = await authFetch(
        `${config.apiBaseUrl}/api/users/id-by-organization?organization=${orgQueryParam}`
      );
      if (!responseIds.ok)
        throw new Error(`HTTP error! status: ${responseIds.status}`);

      const userIds = await responseIds.json();

      //console.log("Fetched user IDs:", userIds);

      const userIdsParam = Array.isArray(userIds) ? userIds.join(",") : userIds;

      const responseEmails = await authFetch(
        `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
      );
      if (!responseEmails.ok)
        throw new Error(`HTTP error! status: ${responseEmails.status}`);

      const emails = await responseEmails.json();

      setEmails(emails);
      //console.log("Fetched emails:", emails);

      handleChange("foruserid", userIds);

      if (Array.isArray(val) && val.length === 0) {
        handleChange("affectedCustomer", [organization]);
      } else {
        handleChange("affectedCustomer", [val]);
      }
    } catch (error) {
      console.error("Failed to fetch customer or emails:", error);
    }
  };
  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    const storedPosition = localStorage.getItem("position") ?? "";
    if (storedUsername) {
      setChange((prev) => ({
        ...prev,
        createdby: storedUsername,
        responsiblePerson: storedUsername,
        responsibleTeam: storedPosition,
      }));
    }
  }, []);
  useEffect(() => {
    if (organization) {
      fetchCustomerData(organization);
    }
  }, [organization]);
  const handleChange = (field: keyof Change, value: any) => {
    setChange((prev) => {
      // Start by copying previous state and updating the field
      const updated = { ...prev, [field]: value };

      updated.affectedSite =
        isallsite === "true" ? ["All Sites"] : updated.affectedSite;
      updated.affectedLink =
        isalllink === "true" ? ["All Links"] : updated.affectedLink;
      updated.affectedNetwork =
        isallnetwork === "true" ? ["All Networks"] : updated.affectedNetwork;

      // Validate Change Close Date
      if (
        (field === "changeCloseDatetime" || field === "changeStartDatetime") &&
        updated.changeCloseDatetime &&
        updated.changeStartDatetime &&
        new Date(updated.changeCloseDatetime) <
          new Date(updated.changeStartDatetime)
      ) {
        alert("Change Close Date/Time must be after Change Start Date/Time");
        return prev; // Reject update
      }

      // Validate Impact Planned end date/time
      if (
        (field === "impactchangeCloseDatetime" ||
          field === "imapctchangeStartDatetime") &&
        updated.impactchangeCloseDatetime &&
        updated.imapctchangeStartDatetime &&
        new Date(updated.impactchangeCloseDatetime) <
          new Date(updated.imapctchangeStartDatetime)
      ) {
        alert(
          "Impact Planned end Date/Time must be after Impact Planned start Date/Time"
        );
        return prev; // Reject update
      }

      return updated; // Accept update
    });
  };

  const validateForm = (): boolean => {
    if (!change) {
      alert("Change data is not available.");
      return false;
    }

    const requiredFields: (keyof Change)[] = ["changeStartDatetime", "summary"];

    for (const field of requiredFields) {
      const value = change[field];
      if (
        value === undefined ||
        value === null ||
        value.toString().trim() === ""
      ) {
        alert(`Please fill the required field`);
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    //console.log("Submitting Change:", change); // Log the state before submission

    try {
      console.log("change>>>>>>>", change);

      const response = await authFetch(`${config.apiBaseUrl}/api/changes`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(change),
      });
      if (!response.ok) throw new Error("Failed to submit change");
      const savedChange = await response.json();
      // Use the ticket ID generated by the backend (CHN + DB sequence)
      change.ticketId = savedChange.ticketId;

      try {
        const emails = await getRecipients(savedChange);
        const jackson = ["jacksondoumith006@gmail.com"];
        const mso = [
          "g.kattan@bcomsat.com",
          "w.wehbe@bcomsat.com",
          "e.moukhaiber@bcomsat.com",
          "n.vanheerden@bcomsat.com",
          "r.mdazevedo@bcomsat.com",
          "r.tuyama@bcomsat.com",
          "g.chouard@bcomsat.com",
          "j.bassante@bcomsat.com",
          "c.nakhle@bcomsat.com",
          "j.sbeit@bcomsat.com",
          "jacksondoumith006@gmail.com",
          "v.digbeu@bcomsat.com",
        ];
        const isallsite = localStorage.getItem("isAllSite");
        const isallnetwork = localStorage.getItem("isAllNetwork");
        const isalllink = localStorage.getItem("isAllLink");
        const siteInfo =
          isallsite === "true" ? "All Sites" : change.affectedSite ?? "";
        const linkInfo =
          isalllink === "true" ? "All Links" : change.affectedLink ?? "";
        const networkInfo =
          isallnetwork === "true"
            ? "All Networks"
            : change.affectedNetwork ?? "";
        await authFetch(`${config.apiBaseUrl}/api/email/send`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            to: emails,
            //  emails
            subject: `Change ID ${change.ticketId} | ${change.affectedCustomer} | - added to You`,
            body: `
                    Hello <br><br>
                    A change with ID ${
                      change.ticketId
                    } has been opened with the following comments: <br><br>
                      Customer: ${change.affectedCustomer} <br><br>
              <strong>Network:</strong> ${change.affectedNetwork ?? ""}<br><br>
              <strong>Site:</strong> ${change.affectedSite ?? ""}<br><br>
              <strong>Link:</strong> ${change.affectedLink ?? ""}<br><br>

                     <strong>Planned start date/time:</strong> ${
                       change.changeStartDatetime
                         ? change.changeStartDatetime.replace("T", " ")
                         : ""
                     }<br><br>

        <strong>Planned close date/time:</strong> ${
          change.changeCloseDatetime
            ? change.changeCloseDatetime.replace("T", " ")
            : ""
        }<br><br>
                      Summary: ${change.summary} <br><br>
                      Description: ${change.description} <br><br>
                      Closure code: ${change.closureCode} <br><br>
                      Solution: ${change.solution}
                      <br><br>
                      Regards, <br><br>

                               <p>
              <a href=https://bdm.bcomsat.com/" target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Change Details
              </a>
            </p>

       <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">
         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            Value-Added Service<br>
            Tel. & WhatsApp msg: +41 225521085<br>
            Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
          </div>
        </td>
      </tr>
    </table>
              </div>

                    `,
          }),
        });
        localStorage.setItem("email", change.email);
        //console.log("Email sent successfully!");
      } catch (emailErr) {
        console.error("Failed to send email notification:", emailErr);
      }

      alert(`Change ${savedChange.ticketId} submitted successfully!`);
      setChange(initialChange);
      navigate("/change");
    } catch (error) {
      alert(`Submission error: ${(error as Error).message}`);
      console.error(`Submission error: ${(error as Error).message}`);
    }
  };



  return (
    <div className="change-form">
      <section className="form-section">
        <h3>Change Information</h3>

        <div className="grid">
          <Input
            type="text"
            label="Created By"
            value={change.createdby ?? ""}
            onChange={(val) => handleChange("createdby", val)}
            readOnly
          />
          {isAdmin && (
            <ApiDropdown
              api="users/fullnames"
              labelKey="fullName"
              valueKey="id"
              label="User"
              onChange={async (val) => {
                handleChange("userid", val);
                try {
                  const res = await authFetch(
                    `${config.apiBaseUrl}/api/users/${val}`
                  );
                  if (!res.ok) throw new Error("User not found");
                  const user = await res.json();
                  handleChange("email", user.email);
                } catch (err) {
                  console.error("Error fetching user:", err);
                }
              }}
            />
          )}
          {!isAdmin && (
            <ApiDropdown
              api={`users/by-organization/${organization}`}
              labelKey="username"
              valueKey="id"
              label="User"
              onChange={async (val) => {
                handleChange("userid", val);
                try {
                  const res = await authFetch(
                    `${config.apiBaseUrl}/api/users/${val}`
                  );
                  if (!res.ok) throw new Error("User not found");
                  const user = await res.json();
                  handleChange("email", user.email);
                } catch (err) {
                  console.error("Error fetching user:", err);
                }
              }}
            />
          )}
          <Input
            readOnly
            type="text"
            label="Ticket ID"
            value={change.ticketId || ""}
            placeholder="Generated on save"
            onChange={() => {}}
          />

          <Input
            type="datetime-local"
            label="Planned start Date/Time (UTC)"
            required={true}
            value={change.changeStartDatetime}
            onChange={(val) => handleChange("changeStartDatetime", val)}
          />
          <Input
            type="datetime-local"
            label="Planned End Date/Time (UTC)"
            required={true}
            value={change.changeCloseDatetime}
            onChange={(val) => handleChange("changeCloseDatetime", val)}
          />
          <Input
            type="datetime-local"
            label="Impact Planned Start Date/Time (UTC)"
            value={change.imapctchangeStartDatetime}
            onChange={(val) => handleChange("imapctchangeStartDatetime", val)}
          />
          <Input
            type="datetime-local"
            label="Impact Planned end Date/Time (UTC)"
            value={change.impactchangeCloseDatetime}
            onChange={(val) => handleChange("impactchangeCloseDatetime", val)}
          />
          {isAdmin && (
            <>
              <Checkbox
                label="Customer Approval"
                onChange={(e) =>
                  handleChange("customerapproval", e.target.checked)
                }
                checked={change.customerapproval}
              />
              <Checkbox
                label="CAB Approval"
                onChange={(e) => handleChange("cabapproval", e.target.checked)}
                checked={change.cabapproval}
              />
            </>
          )}
        </div>
      </section>
      <section className="form-section">
        <h3>Customer & Network</h3>
        <div className="grid">
          {!isAdmin && (
            <ApiDropdown
              api="affected-customers"
              required={true}
              labelKey="customername"
              disabled
              value={organization}
              valueKey="customername"
              label="Customer"
              isMulti
              onOpen={async () => {
                try {
                  const responseIds = await authFetch(
                    `${config.apiBaseUrl}/api/users/id-by-organization?organization=${organization}`
                  );
                  if (!responseIds.ok)
                    throw new Error(
                      `HTTP error! status: ${responseIds.status}`
                    );
                  const userIds = await responseIds.json();
                  //console.log("Fetched user IDs:", userIds);

                  const userIdsParam = Array.isArray(userIds)
                    ? userIds.join(",")
                    : userIds;
                  const responseEmails = await authFetch(
                    `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                  );
                  if (!responseEmails.ok)
                    throw new Error(
                      `HTTP error! status: ${responseEmails.status}`
                    );
                  const emails = await responseEmails.json();
                  setEmails(emails);
                  //console.log("Fetched emails:", emails);

                  handleChange("foruserid", userIds);

                  handleChange("affectedCustomer", [organization]);
                } catch (error) {
                  console.error("Failed to fetch customer or emails:", error);
                }
              }}
            />
          )}
          {isAdmin && (
            <ApiDropdown
              api="affected-customers"
              labelKey="customername"
              required={true}
              valueKey="customername"
              label="Customer"
              isMulti
              onChange={async (val) => {
                setCustomer(val);
                handleChange("affectedCustomer", val);
                try {
                  const responseIds = await authFetch(
                    `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`
                  );
                  if (!responseIds.ok)
                    throw new Error(
                      `HTTP error! status: ${responseIds.status}`
                    );
                  const userIds = await responseIds.json();
                  //console.log("Fetched user IDs:", userIds);

                  const userIdsParam = Array.isArray(userIds)
                    ? userIds.join(",")
                    : userIds;
                  const responseEmails = await authFetch(
                    `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                  );
                  if (!responseEmails.ok)
                    throw new Error(
                      `HTTP error! status: ${responseEmails.status}`
                    );
                  const emails = await responseEmails.json();
                  setEmails(emails);
                  //console.log("Fetched emails:", emails);

                  handleChange("foruserid", userIds);
                } catch (error) {
                  console.error("Failed to fetch customer or emails:", error);
                }
              }}
            />
          )}
          {!isAdmin && organization && (
            <ApiDropdown
              api={`everything/networks?customer=${organization}`}
              labelKey="label"
              valueKey="value"
              label=" Networks"
              required={true}
              isMulti
              onChange={(val) => {
                setNetwork(val);
                handleChange("affectedNetwork", val);
              }}
            />
          )}

          {!isAdmin && organization && (
            <>
              {network && (
                <ApiDropdown
                  api={`everything/sites?customer=${organization}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label=" Site"
                  isMulti
                  onChange={(val) => {
                    setSite(val);
                    handleChange("affectedSite", val);
                  }}
                />
              )}

              {site && (
                <ApiDropdown
                  api={`everything/links?customer=${organization}&network=${network}&site=${site}`}
                  labelKey="label"
                  valueKey="value"
                  label=" Link"
                  isMulti
                  onChange={(val) => handleChange("affectedLink", val)}
                />
              )}

              <ApiDropdown
                api={`everything/asset?customer=${organization}&network=${network}`}
                labelKey="label"
                valueKey="value"
                isMulti
                label="Assets"
                onChange={(val) => handleChange("asset", val)}
              />
            </>
          )}

          {isAdmin && (
            <>
              {customer && (
                <ApiDropdown
                  api={`everything/networks?customer=${customer}`}
                  labelKey="label"
                  valueKey="value"
                  label="Networks"
                  required
                  isMulti
                  onChange={(val) => {
                    setNetwork(val);
                    handleChange("affectedNetwork", val);
                  }}
                />
              )}

              {network && (
                <ApiDropdown
                  api={`everything/sites?customer=${customer}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Site"
                  isMulti
                  onChange={(val) => {
                    setSite(val);
                    handleChange("affectedSite", val);
                  }}
                />
              )}

              {site && (
                <ApiDropdown
                  api={`everything/links?customer=${customer}&network=${network}&site=${site}`}
                  labelKey="label"
                  valueKey="value"
                  label="Link"
                  isMulti
                  onChange={(val) => handleChange("affectedLink", val)}
                />
              )}

              <ApiDropdown
                api={`everything/asset?customer=${customer}&network=${network}`}
                labelKey="label"
                valueKey="value"
                label="Assets"
                isMulti
                onChange={(val) => handleChange("asset", val)}
              />

              <ApiDropdown
                api={`everything/antenna?customer=${customer}`}
                labelKey="label"
                valueKey="value"
                label="Antennas"
                isMulti
                onChange={(val) => handleChange("affectedAntenna", joinMulti(val))}
              />
            </>
          )}
        </div>
      </section>
      <section className="form-section">
        <h3>Change severity</h3>
        <div className="grid">
          <ApiDropdown
            api="Urgencys"
            required
            labelKey="name"
            valueKey="name"
            label="Priority"
            onChange={(val) => handleChange("priority", val)}
          />
        </div>
      </section>
      <section className="form-section">
        <h3>Change Details</h3>
        <div className="grid2">
          <TextArea
            label="Summary"
            required={true}
            style={{
              minHeight: "30px",
              minWidth: "90%",
              backgroundColor: "white",
            }}
            value={change.summary}
            onChange={(val) => handleChange("summary", val)}
          />
          <TextArea
            label="Description"
            required={true}
            value={change.description}
            style={{
              minHeight: "100px",
              minWidth: "90%",
              backgroundColor: "white",
            }}
            onChange={(val) => handleChange("description", val)}
          />
          {isAdmin && (
            <>
              <TextArea
                label="Risk"
                value={change.risk}
                style={{
                  minHeight: "30px",
                  minWidth: "90%",
                  backgroundColor: "white",
                }}
                onChange={(val) => handleChange("risk", val)}
              />
              <TextArea
                label="RollBack Strategy "
                value={change.rollbackstrategy}
                style={{
                  minHeight: "30px",
                  minWidth: "90%",
                  backgroundColor: "white",
                }}
                onChange={(val) => handleChange("rollbackstrategy", val)}
              />
              <ApiDropdown<Person>
                api="requiredResources"
                labelKey="name"
                valueKey="name"
                label="Required Resources"
                isMulti
                onChange={(val) => handleChange("requiredresources", val)}
              />
            </>
          )}
        </div>
      </section>
      {isAdmin && (
        <section className="form-section">
          <h3>Type of Change</h3>
          <div className="grid">
            <ApiDropdown
              api="ChangeTemplates"
              required
              labelKey="name"
              valueKey="name"
              label="Change Templates"
              onChange={(val) => handleChange("changetemplate", val)}
            />
            <ApiDropdown
              api="TypeOfChanges"
              required
              labelKey="name"
              valueKey="name"
              label="Type of Change"
              onChange={(val) => handleChange("typeofchange", val)}
            />
          </div>
        </section>
      )}
      {/* <section className="form-section">
        <h3>SLA & OLA</h3>
        <div className="grid">
          {isAdmin && (
            <>
              <Input
                type="text"
                label="OLA"
                value={change.ola}
                onChange={(val) => handleChange("ola", val)}
              />
              <Input
                type="text"
                label="OLA Status"
                value={change.olaStatus}
                onChange={(val) => handleChange("olaStatus", val)}
              />
            </>
          )}
        </div>
      </section> */}
      {isAdmin && (
        <section className="form-section">
          <h3>Responsibilty</h3>
          <div className="grid">
            <>
              {change.responsiblePerson ? (
                <>
                  <Input
                    type="text"
                    label="Responsible Person"
                    required={true}
                    value={change.responsiblePerson}
                    onChange={(val) => handleChange("responsiblePerson", val)}
                  />
                  <Input
                    type="text"
                    label="Responsible Team"
                    required={true}
                    value={change.responsibleTeam}
                    onChange={(val) => handleChange("responsibleTeam", val)}
                  />
                </>
              ) : (
                <>
                  <Input
                    type="text"
                    label="Responsible Person"
                    required={true}
                    value={username ?? ""}
                    onChange={(val) => handleChange("responsiblePerson", val)}
                  />
                  <Input
                    type="text"
                    label="Responsible Team"
                    required={true}
                    value={change.responsibleTeam}
                    onChange={(val) => handleChange("responsibleTeam", val)}
                  />
                </>
              )}
            </>
          </div>
        </section>
      )}
      <section className="form-section">
        <h3>Related Object</h3>
        <div className="grid">
          <>
            {" "}
            <FileUploader
              value={change.filePath}
              onRemove={(path) =>
                handleChange("filePath", (change.filePath || []).filter((p: any) => p !== path))
              }
              onChange={async (files, paths) => {
                if (!files || !paths.length) return;

                const uploadedPaths: string[] = [];

                for (let i = 0; i < files.length; i++) {
                  const safeFileName = files[i].name.replace(/\s+/g, "_");

                  // Create a new File object with the updated name
                  const renamedFile = new File([files[i]], safeFileName, {
                    type: files[i].type,
                  });

                  const formData = new FormData();
                  formData.append("file", renamedFile);

                  try {
                    const response = await authFetch(
                      `${config.apiBaseUrl}/api/changes/upload`,
                      {
                        method: "POST",
                        body: formData,
                      }
                    );

                    if (response.ok) {
                      let { path } = await response.json();

                      // Ensure spaces are replaced with "_" before saving in DB
                      path = path.replace(/\s+/g, "_");

                      uploadedPaths.push(path);
                      console.log(
                        "jacksonnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn",
                        uploadedPaths
                      );
                    } else {
                      console.error(`Upload failed for file: ${safeFileName}`);
                    }
                  } catch (error) {
                    console.error("Error uploading file", error);
                  }
                }

                if (uploadedPaths.length) {
                  handleChange("filePath", [
                    ...(change.filePath || []),
                    ...uploadedPaths,
                  ]);
                }
              }}
            />
            {isAdmin && (
              <>
                <button onClick={handleOpenTaskLookup}>
                  Select Related Ticket
                </button>
                {selectedTask && selectedTask.length > 0 && (
                  <div>
                    <p>
                      <strong>Selected Tasks:</strong>
                    </p>
                    <ul>
                      {selectedTask.map((task, index) => (
                        <li key={index}>{task.ticketId}</li>
                      ))}
                    </ul>
                  </div>
                )}
                <TaskGridLookup
                  isOpen={isTaskLookupOpen}
                  onClose={handleCloseTaskLookup}
                  onSelect={handleTaskSelect}
                />{" "}
              </>
            )}
          </>
        </div>
      </section>
      <div className="submit-section">
        <Button onClick={handleSubmit}>Submit Change</Button>
      </div>
    </div>
  );
};

export default ChangeAdd;
